import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/products/[slug]/components/ProductDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/products/[slug]/components/ProductHero.tsx");
